<company-block-card [title]="'COMPANY_EMPLOYEE_STATUS.HEADER'" [explanationSubTitle]="'COMPANY_EMPLOYEE_STATUS.DESCRIPTION'">
  <ng-container card-body>
    <div class="employee-status-radio">
      <div class="card card-step employee-status-option" [ngClass]="{ 'is-selected': employeeControl.value === true }">
        <div class="card-header">
          <app-radio-button
            [id]="'employee-yes'"
            [value]="true"
            [name]="'employeeStatus'"
            [control]="employeeControl"
            [label]="'COMPANY_EMPLOYEE_STATUS.YES_TITLE' | translate"
          ></app-radio-button>
        </div>
        <div class="card-body px-3">
          <span>{{ "COMPANY_EMPLOYEE_STATUS.YES_DESCRIPTION" | translate }}</span>
        </div>
      </div>

      <div class="card card-step employee-status-option" [ngClass]="{ 'is-selected': employeeControl.value === false }">
        <div class="card-header">
          <app-radio-button
            [id]="'employee-no'"
            [value]="false"
            [name]="'employeeStatus'"
            [control]="employeeControl"
            [label]="'COMPANY_EMPLOYEE_STATUS.NO_TITLE' | translate"
          ></app-radio-button>
        </div>
        <div class="card-body px-3">
          <span>{{ "COMPANY_EMPLOYEE_STATUS.NO_DESCRIPTION" | translate }}</span>
        </div>
      </div>
    </div>

    <ng-container *ngIf="!isEmployee">
      <company-block-card
        [title]="'COMPANY_EMPLOYEE_STATUS.ORG_PROFILE_HEADER'"
        [explanationSubTitle]="'COMPANY_EMPLOYEE_STATUS.ORG_PROFILE_DESCRIPTION'"
        [isMarginBottom]="true"
      >
        <ng-container card-body>
          <div [formGroup]="orgFormGroup">
            <div id="control-org-businessName">
              <app-control-wrapper [control]="orgFormGroup.get('businessName')">
                <label for="orgBusinessName" control-label>
                  {{ "LABELS.ORGANIZATION_NAME" | translate }}
                </label>
                <input
                  type="text"
                  [formControl]="orgFormGroup.get('businessName')"
                  class="form-control"
                  id="orgBusinessName"
                  name="orgBusinessName"
                  [placeholder]="'FORM_PLACEHOLDER.BUSINESS_NAME' | translate"
                  control-wrapper
                  [patterns]="CUSTOM_MASK"
                  mask="F*"
                  [dropSpecialCharacters]="false"
                  appMaskErrorTooltip="MASK_ERROR.ONLY_ENGLISH_DIGITS_AND_SPECIAL"
                />
              </app-control-wrapper>
            </div>

            <identifier-qualifier-update
              [formGroup]="orgFormGroup"
              [isModalPlacement]="true"
              [errors]="{}"
              [controlId]="'orgIdentifierControl'"
            ></identifier-qualifier-update>
          </div>
        </ng-container>
      </company-block-card>
    </ng-container>
  </ng-container>
</company-block-card>
